import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { WidgetDef, GENERATE_NOTE } from '../types';
import { DemoHead, DemoSearch, DocList, DocItem } from '../shared';

// spec 622:4442
const ITEMS: (DocItem & { info: string })[] = [
    { title: 'Annual Report 2026', meta: '30 Jun 2026', info: '96 pages · 2.4 MB', badge: 'Annual', likes: 24, questions: 3 },
    { title: 'Annual Report 2025', meta: '30 Jun 2025', info: '88 pages · 2.4 MB', badge: 'Annual', likes: 16, questions: 2 },
    { title: 'Half-Year Report 2026', meta: '28 Feb 2026', info: '34 pages · 2.4 MB', badge: 'Half-yearly', likes: 9, questions: 1 },
    { title: 'Quarterly Activities & Appendix 5B', meta: '31 Jul 2026', info: '12 pages · 2.4 MB', badge: 'Quarterly', likes: 12, questions: 0 },
];

const financialReports: WidgetDef = {
    slug: 'financial-reports',
    name: 'Financial reports',
    description: 'Annual, half-yearly and quarterly reports',
    icon: <FiFileText />,
    title: 'Financial Reports Widget',
    installed: true,
    page: '/investors/financial-reports/',
    views: 540,
    savedCodes: [
        { path: '/investors/investors-dashboard/', note: 'Latest 3' },
        { path: '/investors/financial-reports/', note: 'Accordion by year' },
    ],
    demoPath: '/investors/financial-reports/',
    addNote: 'This code is generated from the settings below. Change a setting and the code updates — paste it once, it stays current.',
    addBlocks: [
        { title: '1 · WordPress shortcode', code: '[investi_financial_reports instance="financial-reports"]' },
        { title: '2 · Or plain HTML', code: '<div data-investi-instance="financial-reports" data-investi="financial-reports"></div>', dark: true },
    ],
    settings: [
        { kind: 'heading', label: 'Widget style' },
        { kind: 'segmented', key: 'style', options: ['List', 'Tabs', 'Accordion by year', 'Carousel'], default: 'List' },
        { kind: 'heading', label: 'What visitors can do' },
        { kind: 'toggle', key: 'search', label: 'Search box', hint: 'Search by title', default: true },
        { kind: 'toggle', key: 'filterYear', label: 'Filter by year', default: true },
        { kind: 'toggle', key: 'filterType', label: 'Filter by type', hint: 'Annual, half-yearly, quarterly', default: true },
        { kind: 'heading', label: 'What it shows' },
        { kind: 'toggle', key: 'groupByType', label: 'Group by type (annual, half-yearly, quarterly)', default: true },
        { kind: 'toggle', key: 'likes', label: 'Let visitors like a document', hint: 'A like button on every row', default: true },
        { kind: 'toggle', key: 'likeCount', label: 'Show the like count', default: true },
        { kind: 'toggle', key: 'questionCount', label: 'Show the question count', default: true },
        { kind: 'toggle', key: 'questions', label: 'Show the questions section', hint: 'The ask box and published answers', default: true },
        { kind: 'toggle', key: 'fileInfo', label: 'Show the file size and page count', default: true },
        { kind: 'note', text: 'Likes and questions need a signed‑in investor or an email address, so the numbers are real people, not clicks. They appear in Communications › Announcements alongside the announcement.' },
    ],
    generateNote: GENERATE_NOTE,
    Demo: ({ settings: s }) => {
        const items = ITEMS.map(({ info, ...i }) => ({ ...i, meta: s.fileInfo ? `${i.meta} · ${info}` : i.meta }));
        const filters = [s.filterType && 'Type: All', s.filterYear && 'Year: All'].filter(Boolean) as string[];
        return <>
            <DemoHead title="Financial reports" sub="Annual, half-yearly and quarterly" />
            <DemoSearch placeholder="Search reports…" showSearch={!!s.search} filters={filters} />
            <DocList items={items} likes={!!s.likes} likeCount={!!s.likeCount} questionCount={!!s.questionCount} />
        </>;
    },
};

export default financialReports;
